export interface SoftwareInterface {
  code: SoftwareHubbixCode;
  name: SoftwareName;
}

export enum SoftwareStatus {
  AVAILABLE = 'Disponible',
  DEMO = 'Essai',
  OPEN = 'Accéder',
  UNSUBSCRIBE_PROGRESS = 'En cours de retrait',
  BLOCKED = 'Bloqué',
}

export enum SoftwareTrialStatus {
  None = 0, // (Description : Aucune) // Correspond aux domaines achetés sans période d'essai
  InProgress = 1, // (Description : En cours)
  Expired = 2, // (Descrption : Expirée)
  Buyed = 3, // (Description : Achetée) // Correspond aux domaines achetée suite à une période d'essai
  Blocked = 4, // (Description : Bloquée)
}

export enum SoftwareHubbixCode {
  INV = 1, // Gestion commerciale
  ACC = 2, // Comptabilité
  PAI = 512, // Paie
  BAT = 2048, // Batiment
  ACC_PME = 4096, // Compta PME
  INV_PME = 8192, // Gestion PME
  PAI_EDT = 1638, // Paie editeur
  INV_S = 32768, // Gestion commerciale silver
  ACC_S = 65536, // Comptabilité silver
}

export enum SoftwareSapCode {
  INV = '1029J001FAC', // Gestion commerciale
  ACC = '1036J001FAB', // Comptabilité
  PAI = '1025J001FAE', // Paie
  BAT = '1039J001FAA', // Batiment
  ACC_PME = '4096', // Compta PME
  INV_PME = '8192', // Gestion PME
  PAI_EDT = '1638', // Paie editeur
  INV_S = '1029J004FAD', // Gestion commerciale silver
  ACC_S = '1036J004FAD', // Comptabilité silver
}

export const SoftwareHubbixCodes = [
  SoftwareHubbixCode.INV,
  SoftwareHubbixCode.ACC,
  SoftwareHubbixCode.PAI,
  SoftwareHubbixCode.BAT,
  SoftwareHubbixCode.ACC_PME,
  SoftwareHubbixCode.INV_PME,
  SoftwareHubbixCode.PAI_EDT,
  SoftwareHubbixCode.INV_S,
  SoftwareHubbixCode.ACC_S,
];

export const softwareFlagName = ['INV', 'ACC', 'PAI', 'BAT', 'ACC_PME', 'INV_PME', 'PAI_EDT', 'INV_S', 'ACC_S'];

export enum SoftwareName {
  INV = 'Gestion commerciale',
  ACC = 'Comptabilité',
  PAI = 'Paie',
  BAT = 'Bâtiment',
  ACC_PME = 'Comptabilité PME',
  INV_PME = 'Gestion PME',
  PAI_EDT = 'Paie Editeur',
  INV_S = 'Gestion commerciale',
  ACC_S = 'Comptabilité',
}

export const softwareNames = [
  SoftwareName.INV,
  SoftwareName.ACC,
  SoftwareName.PAI,
  SoftwareName.BAT,
  SoftwareName.ACC_PME,
  SoftwareName.INV_PME,
  SoftwareName.PAI_EDT,
  SoftwareName.INV_S,
  SoftwareName.ACC_S,
];

export enum SoftwareColor {
  INV = '#9333ff',
  ACC = '#42a5f5',
  PAI = '#4CAF50',
  BAT = '#FF9800',
  ACC_PME = '#E53935',
  INV_PME = '#EC407A',
  PAIE_EDT = '#4CAF50',
  INV_S = '#9333ff',
  ACC_S = '#42a5f5',
  DEFAULT = '#00bfa5',
}

export const SoftwareNameByFlag: { [key: string]: string } = {
  INV: SoftwareName.INV,
  ACC: SoftwareName.ACC,
  PAI: SoftwareName.PAI,
  BAT: SoftwareName.BAT,
  ACC_PME: SoftwareName.ACC_PME,
  INV_PME: SoftwareName.INV_PME,
  PAIE_EDT: SoftwareName.PAI_EDT,
  INV_S: SoftwareName.INV_S,
  ACC_S: SoftwareName.ACC_S,
};

export const SoftwareColorByCode: { [key: number]: string } = {
  0: SoftwareColor.DEFAULT,
  1: SoftwareColor.INV,
  2: SoftwareColor.ACC,
  512: SoftwareColor.PAI,
  2048: SoftwareColor.BAT,
  4096: SoftwareColor.ACC_PME,
  8192: SoftwareColor.INV_PME,
  1638: SoftwareColor.PAIE_EDT,
  32768: SoftwareColor.INV_S,
  65536: SoftwareColor.ACC_S,
};

export const SoftwareColorByCodeSap: { [key: string]: string } = {
  default: SoftwareColor.DEFAULT,
  '1029J001FAC': SoftwareColor.INV,
  '1036J001FAB': SoftwareColor.ACC,
  '1025J001FAE': SoftwareColor.PAI,
  '1039J001FAA': SoftwareColor.BAT,
  '4096': SoftwareColor.ACC_PME,
  '8192': SoftwareColor.INV_PME,
  '1638': SoftwareColor.PAIE_EDT,
  '1029J004FAD': SoftwareColor.INV_S,
  '1036J004FAD': SoftwareColor.ACC_S,
};

export const getSoftwareNameByFlag = (flag: string): string => {
  return SoftwareNameByFlag[flag] ? SoftwareNameByFlag[flag].toString() : 'Inconnu';
};

export const getSoftwareNameByNumber = (access: number): string[] => {
  const sofwareAccess = SoftwareHubbixCodes.filter((item) => (access & item) === item, access);
  return sofwareAccess.map((sofwareCode) => {
    if (sofwareCode == SoftwareHubbixCode.BAT) return SoftwareName.BAT;
    if (sofwareCode == SoftwareHubbixCode.PAI) return SoftwareName.PAI;
    if (sofwareCode == SoftwareHubbixCode.ACC) return SoftwareName.ACC;
    if (sofwareCode == SoftwareHubbixCode.INV) return SoftwareName.INV;
    if (sofwareCode == SoftwareHubbixCode.ACC_PME) return SoftwareName.ACC_PME;
    if (sofwareCode == SoftwareHubbixCode.INV_PME) return SoftwareName.INV_PME;
    if (sofwareCode == SoftwareHubbixCode.PAI_EDT) return SoftwareName.PAI_EDT;
    if (sofwareCode == SoftwareHubbixCode.INV_S) return SoftwareName.INV_S;
    if (sofwareCode == SoftwareHubbixCode.ACC_S) return SoftwareName.ACC_S;
    return 'Aucun Accès';
  });
};
